/*
 * Product sharing (snippets/ams-product-share).
 * - Shows "Distribuie" where the browser has a share sheet (mostly phones).
 * - "Copiază linkul" copies the message, title and link in one go.
 */
(function () {
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      } finally {
        document.body.removeChild(area);
      }
    });
  }

  function init(box) {
    var data = {
      title: box.getAttribute('data-title'),
      text: box.getAttribute('data-text'),
      url: box.getAttribute('data-url')
    };
    var status = box.querySelector('[data-ams-share-status]');
    function say(message) {
      if (!status) return;
      status.textContent = message;
      clearTimeout(status._t);
      status._t = setTimeout(function () { status.textContent = ''; }, 3000);
    }

    var native = box.querySelector('[data-ams-share-native]');
    if (native && navigator.share) {
      native.hidden = false;
      native.addEventListener('click', function () {
        navigator.share(data).catch(function () {});
      });
    }

    var copyButton = box.querySelector('[data-ams-share-copy]');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        copy(data.text + ' ' + data.url).then(
          function () { say('Linkul a fost copiat.'); },
          function () { say('Nu am putut copia. Copiază adresa din bara browserului.'); }
        );
      });
    }
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ams-share]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
